export default __webpack_public_path__ + "static/media/default_help.c7645204.txt";